import styled from 'styled-components';

// // Create the keyframes
// const shake = keyframes`
//   10%, 90% {
//     transform: translate3d(-1px, 0, 0);
//   }

//   20%, 80% {
//     transform: translate3d(2px, 0, 0);
//   }

//   30%, 50%, 70% {
//     transform: translate3d(-4px, 0, 0);
//   }

//   40%, 60% {
//     transform: translate3d(4px, 0, 0);
//   }
// `;

export const AnswersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
